import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../config/analytics';

/**
 * Custom hook to track page views automatically
 * Use this hook in your main App component to track all route changes
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    trackPageView(location.pathname + location.search);
  }, [location]);
};

/**
 * Custom hook to track page views with custom titles
 * Use this in individual pages for more specific tracking
 */
export const usePageTrackingWithTitle = (title: string) => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search, title);
  }, [location, title]);
};
